import { useCallback, useEffect, useState } from 'react';
import { apiClient } from '../api/client';
import { logger } from './logger';

const errText = (e) => e?.response?.data?.detail || e?.message || 'Hata';

/** ⚡ Hızlı Kâr Botu: durum (10 sn'de bir) + aksiyonlar. */
export function useScalper() {
    const [status, setStatus] = useState(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        try {
            const { data } = await apiClient.get('/scalper/status');
            setStatus(data);
        } catch (e) {
            logger.warn('scalper status failed', e);
        }
    }, []);

    const act = useCallback(async (fn) => {
        setBusy(true);
        setError(null);
        try {
            const r = await fn();
            await load();
            return r;
        } catch (e) {
            setError(errText(e));
            throw e;
        } finally {
            setBusy(false);
        }
    }, [load]);

    const start = useCallback((mode) => act(() => apiClient.post('/scalper/start', { mode })), [act]);
    const stop = useCallback((close) => act(() => apiClient.post('/scalper/stop', { close: !!close })), [act]);
    const save = useCallback((patch) => act(() => apiClient.put('/scalper/settings', patch)), [act]);
    const closeOpen = useCallback(() => act(() => apiClient.post('/scalper/close')), [act]);

    useEffect(() => {
        load();
        const id = setInterval(load, 10000);
        return () => clearInterval(id);
    }, [load]);

    return { status, busy, error, reload: load, start, stop, save, closeOpen };
}
